<app-header></app-header>
<section>
    <router-outlet></router-outlet>
    <div class="container-fluid banner-city" style="background-image: url({{envtemplate.bannerbackground}});">
      <img src="{{envtemplate.banner}}" class="autos" alt="">
    </div>
</section>
<!--<app-whatsapp></app-whatsapp>-->
<app-footer></app-footer>
